import Component from '@glimmer/component';
import { service } from '@ember/service';
import { trackedFunction } from 'reactiveweb/function';
import { tracked } from '@glimmer/tracking'; // still needed for error
import type EmployeeModel from 'tio-data/models/employee';
// This is for types. Anything we have custom may show an error.
import type StoreService from 'ember-data/store';
import type AccountingPaymentModel from 'tio-data/models/accounting-payment';
import { hash } from '@ember/helper';

interface AccountingPaymentsSummary {
  total?: number | null;
}

interface ContributionsAccountingPaymentsSignature {
  Args: {
    employee: EmployeeModel;
  };
  Blocks: {
    default: [
      {
        paymentData: AccountingPaymentModel[];
        summaryData: AccountingPaymentsSummary;
        isLoading: boolean;
      },
    ];
  };
}

export default class ContributionsAccountingPaymentsComponent extends Component<ContributionsAccountingPaymentsSignature> {
  @service declare store: StoreService;

  @tracked error?: Error;

  responseData = trackedFunction(this, async () => {
    const employee = this.args.employee;

    try {
      const data = await this.store
        .adapterFor('employee')
        // @ts-expect-error - Ember Data adapter method not typed
        .getAccountingPaymentContributions(employee.id);
      return data;
    } catch (e) {
      console.error(e);
      this.error = e as Error;
    }
  });

  get data() {
    return this.responseData.value || {};
  }

  get paymentsData(): AccountingPaymentModel[] {
    return this.data?.payments || [];
  }

  get summaryData(): AccountingPaymentsSummary {
    return this.data?.summary || { total: null };
  }

  <template>
    {{yield
      (hash
        paymentData=this.paymentsData
        summaryData=this.summaryData
        isLoading=this.responseData.isPending
      )
    }}
  </template>
}
